import React from "react";

/**
 * PerformanceCards - Grid of performance summary cards
 * Reusable for both Player and Goalkeeper stats
 */
const PerformanceCards = ({ cards, stats, columns = 6 }) => {
  const gridColsClass = {
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6",
  };

  return (
    <div className={`grid grid-cols-2 ${gridColsClass[columns] || "md:grid-cols-6"} gap-4`}>
      {cards.map((card) => {
        const IconComponent = card.icon;
        const value = typeof card.getValue === "function" ? card.getValue(stats) : 0;

        return (
          <div
            key={card.key}
            className="bg-white border border-[#E5E6E8] rounded-xl p-3 md:p-4 min-w-0"
          >
            <div className="flex items-center gap-2 md:gap-3 min-w-0">
              {/* The icon SVGs are Figma exports on an ~80px canvas around a
                  40px tile — the other 40px is the (transparent) drop-shadow
                  region. Below md the grid is two columns, so a card is 156px
                  wide and those 40 invisible pixels ate the label's space: the
                  text column was left ~32px and printed "App/eara/nces" and
                  "28/1". The box is bounded to the visible tile there and the
                  canvas overflows it, so the glyph renders at exactly the same
                  size — nothing is scaled down or cut. From md up the grid is
                  six columns and the box is the untouched original. */}
              <div className="flex-shrink-0 mt-0.5 relative h-10 w-10 md:h-auto md:w-auto">
                <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:static md:translate-x-0 md:translate-y-0">
                  <IconComponent />
                </span>
              </div>
              <div className="flex flex-col min-w-0 flex-1">
                <p className="text-[#6B7280] text-xs mb-1 break-words leading-tight">
                  {card.label}
                </p>
                <p className="text-[#1A212F] font-bold text-2xl break-words leading-tight">
                  {value}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PerformanceCards;
